import { render } from "./FormSales.vue?vue&type=template&id=d53683dc"
import script from "./FormSales.vue?vue&type=script&lang=js"
export * from "./FormSales.vue?vue&type=script&lang=js"

import "./FormSales.vue?vue&type=style&index=0&id=d53683dc&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__